module.exports = __webpack_public_path__ + "img/组 8@2x.f0dca67e.png";